import { useState } from "react";
import "./Security.css";

const Security = ({ setActive }) => {
 const [currentPassword, setCurrentPassword] = useState("");
 const [newPassword, setNewPassword] = useState("");
 const [confrimNewPassword, setConfirmNewPassword] = useState("");

 return (
  <div className="security-mobile">
   <form>
    <div className="form-container">
     <div className="input-container">
      <label htmlFor="current-password">Current Password</label>
      <input
       type="password"
       id="current-password"
       placeholder="Enter current password"
       value={currentPassword}
       onChange={(e) => setCurrentPassword(e.target.value)}
      />
     </div>

     <div className="input-container">
      <label htmlFor="new-password">New Password</label>
      <input
       type="password"
       id="new-password"
       placeholder="Enter new password"
       value={newPassword}
       onChange={(e) => setNewPassword(e.target.value)}
      />
     </div>

     <div className="input-container">
      <label htmlFor="confirm-password">Confirm password</label>
      <input
       type="password"
       id="confirm-passowrd"
       placeholder="Re-enter new password"
       value={confrimNewPassword}
       onChange={(e) => setConfirmNewPassword(e.target.value)}
      />
     </div>
    </div>
   </form>

   <div className="shapBtn-container">
    <p className="shapBtn">Update Password</p>
   </div>
  </div>
 );
};

export default Security;
